module.exports = __webpack_public_path__ + "d6c4bdaac940cc8c1a653a9f41e17b30.svg";